import { setSpecificMessage, includes } from "valibot";
setSpecificMessage(
  includes,
  (issue) => `Contenu invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);